import { render, staticRenderFns } from "./Zhuceye.vue?vue&type=template&id=1274ea32&scoped=true&"
import script from "./Zhuceye.vue?vue&type=script&lang=js&"
export * from "./Zhuceye.vue?vue&type=script&lang=js&"
import style0 from "./Zhuceye.vue?vue&type=style&index=0&id=1274ea32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274ea32",
  null
  
)

export default component.exports